export function target() {
  return ['BasicOptin', 'OptinSMS', 'FormWithImage', 'Form'].includes(
    this.module,
  );
}

export function migrate() {
  if (this.data.idsCRMNovas) {
    const idsCRMNovas = this.data.idsCRMNovas.filter((id) => {
      // clear nulls
      return (
        typeof id === 'string' || (id && typeof id.idCRMNovas === 'string')
      );
    });

    this.data.idsCRMNovas = idsCRMNovas.map((id) => {
      return typeof id === 'string' ? id : id.idCRMNovas;
    });
  }

  if (this.data.idsCRMExistentes) {
    const idsCRMExistentes = this.data.idsCRMExistentes.filter((id) => {
      // clear nulls
      return (
        typeof id === 'string' || (id && typeof id.idCRMExistentes === 'string')
      );
    });

    this.data.idsCRMExistentes = idsCRMExistentes.map((id) => {
      return typeof id === 'string' ? id : id.idCRMExistentes;
    });
  }
}
